export default "./images/WNInfoNoCompassFix2.jpg";